module.exports = __webpack_public_path__ + "static/activebarre-ball-work-08161e047c820ce17a7fd371a26bbb0c.jpg";